import BackToServices from "../../components/button/BackToServices";

const Wedding = () => {
    return (<div className="wrapper">
        <div className="content">
            <div id="single">
                <div id="single-content">
                    <div id="img" className="block">
                        <div className="img-no-wrap-1">
                            <div className="img object-fit">
                                <div className="object-fit-cover">
                                    <img src="/assets/img/bg/wedding.jpg" alt="Matrimonio" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="description" className="block spacer p-top-xl">
                        <div className="description">
                            <p>Per il giorno più importante curiamo ogni dettaglio della tua acconciatura. Il servizio sposa comprende l'acconciatura il giorno del matrimonio e una prova in salone, per definire insieme lo stile perfetto.</p>
                            <p>Su richiesta realizziamo anche le acconciature per le invitate, esclusivamente in salone.</p>
                        </div>
                    </div>

                    <div id="price-list" className="block spacer p-top-xl">
                        <div className="title">
                            <h2 className="hr">Listino prezzi</h2>
                        </div>

                        <div className="price-list">
                            <div className="price-list-items">
                                <div className="price-list-item">
                                    <div className="price-list-item-title">
                                        <h3>Raccolto Sposa</h3>
                                    </div>

                                    <ul className="price-list-item-list-group list-group">
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="list-group-title">In salone
                                                <i style={{ display: 'block', fontSize: '16px', marginTop: '10px' }}>Include acconciatura sposa il giorno del matrimonio + 1 prova in salone</i>
                                            </span>
                                            <span className="list-group-price">425 CHF</span>
                                        </li>

                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="list-group-title">In loco
                                                <i style={{ display: 'block', fontSize: '16px', marginTop: '10px' }}>Include acconciatura sposa il giorno del matrimonio + 1 prova in salone</i>
                                            </span>
                                            <span className="list-group-price">525 CHF</span>
                                        </li>
                                    </ul>
                                </div>

                                <div className="price-list-item">
                                    <div className="price-list-item-title">
                                        <h3>Extras</h3>
                                    </div>

                                    <ul className="price-list-item-list-group list-group">
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="list-group-title">Prova aggiuntiva</span>
                                            <span className="list-group-price">75 CHF</span>
                                        </li>

                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="list-group-title">Invitati
                                                <i style={{ display: 'block', fontSize: '16px', marginTop: '10px' }}>Esclusivamente in salone</i>
                                            </span>
                                            <span className="list-group-price">100/125/150 CHF</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <BackToServices />
                </div>
            </div>
        </div>
    </div>
    )
}

export default Wedding;
